(ns renolit-roofing-service.view.session.forgot-password
  (:require [dev.gethop.session.re-frame.cognito.action.forgot-password :as cognito.forgot-password]
            [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.info-bar :as layout.info-bar]
            [renolit-roofing-service.layout.session :as layout.session]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.shared.domain.miscellaneous :as dom.misc]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.view :as view]))

(def ^:const view-context
  :forgot-password-view)

(def ^:const route-config
  {:name [:forgot-password]})

(def ^:const forgot-password-form-schema
  [:map
   [:email
    dom.misc/email-schema]])

(def ^:const new-password-form-schema
  [:map
   [:verification-code
    [:string]]
   [:new-password
    [:string]]])

(rf/reg-event-fx
 ::evt-failure
 (fn [_ [_ reason]]
   {:dispatch-n [[::layout.info-bar/add-info-bar
                  {:context view-context
                   :disappear-in-ms 5000
                   :type :error
                   :msg-transl-kw
                   (condp = reason
                     :code-mismatch
                     (t [:error-msg.invalid-code])
                     (t [:error-msg.unknown]))}]
                 [::util/generic-error reason]]}))

(defn- on-new-password-form-submit
  [state]
  (let [credentials (m/encode new-password-form-schema @state mt/strip-extra-keys-transformer)
        form-errors (form.error/check-errors new-password-form-schema credentials)]
    (if form-errors
      (rf/dispatch [::form.error/register-errors view-context form-errors])
      (rf/dispatch [::cognito.forgot-password/user-reset-password-confirmation
                    (:new-password credentials)
                    (:verification-code credentials)
                    {:on-success-evt [::nav/push-state :login]
                     :on-failure-evt [::evt-failure]}]))))

(defn- on-forgot-password-form-submit
  [form-type state]
  (let [credentials (m/encode forgot-password-form-schema @state mt/strip-extra-keys-transformer)
        form-errors (form.error/check-errors forgot-password-form-schema credentials)]
    (if form-errors
      (rf/dispatch [::form.error/register-errors view-context form-errors])
      (do (reset! form-type :new-password-challenge)
          (rf/dispatch [::form.error/clear-errors view-context])
          (rf/dispatch [::cognito.forgot-password/user-request-password-reset
                        (:email credentials)
                        {:on-failure-evt [::evt-failure]}])))))

(defn- new-password-form
  []
  (let [state (r/atom {})]
    (fn []
      [:form.simple-form.login_form
       {:on-submit
        (fn [e]
          (.preventDefault e)
          (on-new-password-form-submit state))}
       [layout.form/item
        {:context view-context
         :type :input
         :input-type :password
         :state state
         :path [:new-password]
         :label-transl-kw :label.new-password
         :schema [:string]}]
       [layout.form/item
        {:context view-context
         :type :input
         :state state
         :path [:verification-code]
         :label-transl-kw :label.verification-code
         :schema [:string]}]
       [:div.simple-form__actions
        [:button.btn.btn--primary
         {:type :submit}
         (t [:button.change-password])]]])))

(defn- forgot-password-form
  [_form-type]
  (let [state (r/atom {})]
    (fn [form-type]
      [:form.simple-form.login_form
       {:on-submit
        (fn [e]
          (.preventDefault e)
          (on-forgot-password-form-submit form-type state))}
       [layout.form/item
        {:context view-context
         :type :input
         :state state
         :path [:email]
         :mandatory? true
         :label-transl-kw :label.email
         :placeholder-transl-kw :placeholder.email
         :schema [:string]}]
       [:div.simple-form__actions
        [:button.btn.btn--primary
         {:type :submit}
         (t [:button.recover-password])]]])))

(defn- main
  []
  (let [form-type (r/atom :forgot-password)]
    (fn []
      [layout.session/layout
       [:<>
        [:div.session_main-description
         [:h3.session_main-description-title
          (t [:page.forgot-password.title])]
         [:span.session_main-description-subtitle
          (t [:page.forgot-password.subtitle])]]
        (case @form-type
          :new-password-challenge
          [new-password-form]
          [forgot-password-form form-type])]])))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
